import React from "react";
import { EarningsFactsSection } from "../../components/home/EarningsFactsSection";
import { getFaqItemsByQuestion } from "../../seo/faqContent.js";
import { SEO_LINKS } from "../../seo/siteMetadata.js";
import { FaqSection, SeoHero, SeoLinkGrid, TextSection } from "../../pages/seo/SeoPageBlocks";

export default function ProvisionContent() {
  return (
    <div className="bg-slate-50">
      <SeoHero
        eyebrow="Provision och utbetalning"
        title="Räkna på gruppens förtjänst"
        description="Prova olika mål och gruppstorlekar i kalkylatorn. Den använder 74 kr i genomsnittlig provision per såld produkt som planeringsvärde."
        primaryCtaLabel="Räkna på förtjänsten"
        primaryCtaTo="#kalkylator"
      />

      <TextSection
        eyebrow="Produktbunden provision"
        title="Förtjänsten beror på vad och hur mycket gruppen säljer"
      >
        <p>
          Varje produkt eller variant har en provision. Gruppens beräknade förtjänst är summan av antal sålda
          produkter multiplicerat med respektive produkts provision.
        </p>
        <p>
          Kalkylatorn nedan använder 74 kr som genomsnitt för att göra planeringen enkel. Det slutliga
          beloppet räknas alltid på provisionen för de produkter och varianter som faktiskt säljs.
        </p>
      </TextSection>

      <EarningsFactsSection compact />

      <TextSection
        eyebrow="Efter kampanjen"
        title="Utbetalning kan göras efter leverans och väntetid"
        tone="muted"
      >
        <p>
          Enligt utbetalningsvillkoren kan gruppen begära utbetalning när alla kampanjens beställningar har
          levererats och 14 dagar har passerat.
        </p>
        <p>
          Returer och återbetalningar kan minska det slutliga beloppet. Gruppens bankuppgifter behöver vara
          registrerade innan en utbetalning kan genomföras.
        </p>
      </TextSection>

      <FaqSection
        title="Vanliga frågor om provision"
        items={getFaqItemsByQuestion([
          "Hur mycket tjänar gruppen?",
          "När betalas förtjänsten ut?",
          "Vad kan vi sälja?",
        ]).map(({ q, a }) => ({ q, a }))}
      />
      <SeoLinkGrid links={SEO_LINKS.filter((link) => link.to !== "/provision-och-fortjanst")} />
    </div>
  );
}
